import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import axios from "axios";
import SecondaryHeader from "../../Components/Header/SecondaryHeader";
import CommonCard from "../../Components/DashboardCard/commonCard";
import CreditCard from "../../Components/DashboardCard/creditCard";
import { useCompanyData } from "../../context/MasterContextProvider";
import { format } from "date-fns";
import { ApplicationModel } from "../../models/application";
import { REGIONS } from "../../constants/regions";
import { useRegion } from "../../context/RegionContext";
import { icons } from "../../assets/images";

const Dashboard = () => {
  const navigate = useNavigate();
  const { region, changeRegion } = useRegion();
  const { company } = useCompanyData();

  // Sync region with company's countryCode when company data is loaded
  useEffect(() => {
    if (company?.countryPreference) {
      // Convert countryCode to region: "AE" -> "uae", "SA" -> "ksa"
      const regionFromCountryCode =
        company.countryPreference.toLowerCase() === "uae"
          ? REGIONS.AE
          : REGIONS.SA;

      // Only update if the region doesn't match the company's countryCode
      // and there's no URL parameter overriding it
      const urlParams = new URLSearchParams(window.location.search);
      const urlRegion = urlParams.get("region")?.toLowerCase();

      // If no URL parameter and region doesn't match company, update it
      if (!urlRegion && region !== regionFromCountryCode) {
        changeRegion(regionFromCountryCode);
      }
    }
  }, [company?.countryCode, region, changeRegion]);

  const handleJobsClick = () => {
    navigate("/dashboard/jobsposted");
  };
  const handleApplicationClick = () => {
    navigate("/dashboard/applications");
  };

  const handlePlaceClick = () => {
    navigate("/dashboard/placements");
  };

  const handleCvClick = () => {
    navigate("/searchcv");
  };

  const [totalCv, setTotalCv] = useState(0);
  const [ApplicationsData, setApplicationsData] = useState<ApplicationModel>();

  const applications = async () => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_BASE_URL}/candidate/jobs/applications/all/job`,

        {
          page: 1,
          limit: 20000,
          filters: {
            jobName: null,
            status: null,
            companyId: localStorage.getItem("companyId"),
          },
        },
        {
          headers: {
            Authorization: localStorage.getItem("userId"),
          },
        }
      );

      if (response.data.statusCode === "OK") {
        setApplicationsData(response.data.data);
      } else {
        // console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const searchAllData = async () => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_BASE_URL}/candidate/profile/get/list/search`,

        {
          page: 1,
          limit: 10,
          filters: {
            // minYears: null,
            // maxYears: 100,
            // stateId: [],
          },
          keyword: "",
          companyId: localStorage.getItem("companyId") || "",
        },
        {
          headers: {
            Authorization: localStorage.getItem("userId"),
          },
        }
      );

      if (response.data.statusCode === "OK") {
        setTotalCv(response.data.data.totalRecords);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      // setLoading(false);
    }
  };
  useEffect(() => {
    searchAllData();
    applications();
  }, []);

  function formatExpiryDate(planExpiryDate: string) {
    const date = new Date(planExpiryDate);
    return format(date, "d MMM, yyyy"); // Format as "24 Feb, 2025"
  }

  return (
    <div className="">
      {/* <Sidenav /> */}
      <div className="relative">
        <SecondaryHeader title={"Dashboard"} />
        <div className="dashboard_main_container">
          <h2>Plan & Credit Details</h2>
          {company?.credits && (
            <div className="container">
              <CreditCard
                title="Plan Expires On"
                number={
                  company?.credits?.planExpiryDate
                    ? formatExpiryDate(company?.credits.planExpiryDate || "")
                    : "24 Feb, 2025"
                }
                isActive={true}
              />
              <CreditCard
                title="Jobs Credit"
                number={
                  company?.credits.jobCreditsUsed +
                  "/" +
                  company?.credits.totalJobCredits
                }
              />
              <CreditCard
                title="Contacts Credit"
                number={
                  company?.credits.creditsUsed +
                  "/" +
                  company?.credits.totalCredits
                }
              />
            </div>
          )}
          <br />
          <h2>Insights</h2>
          {company && (
            <div className="container">
              <CommonCard
                icon={icons.emiratiProfile}
                onClick={handleCvClick}
                number={totalCv}
                title="National Talents"
                btnText={`View Profiles`}
              />
              <CommonCard
                icon={icons.jobsPosted}
                onClick={handleJobsClick}
                number={company?.dashboardInfo?.jobsPosted || 0}
                title="Jobs Posted"
                btnText="View Jobs Posted"
              />
              <CommonCard
                icon={icons.applications}
                onClick={handleApplicationClick}
                number={ApplicationsData?.totalRecords || 0}
                title="Applications"
                btnText="View Applications"
              />
              <CommonCard
                icon={icons.placements}
                onClick={handlePlaceClick}
                number={company?.dashboardInfo?.placements || 0}
                title="Placements"
                btnText="View Placements"
              />
              <CommonCard
                icon={icons.jobViews}
                onClick={handleJobsClick}
                number={company?.dashboardInfo?.totalJobViews || 0}
                title="Job Views"
                btnText="View Jobs Posted"
              />
            </div>
          )}
          <br />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
